import { render, staticRenderFns } from "./OfficeForm.vue?vue&type=template&id=06d07d66&scoped=true&"
import script from "./OfficeForm.vue?vue&type=script&lang=js&"
export * from "./OfficeForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficeForm.vue?vue&type=style&index=0&id=06d07d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d07d66",
  null
  
)

export default component.exports